<template>
  <v-dialog v-model="providersListDialog" width="500">
    <v-card>
      <v-card-title class="subheading ttu">
        <span>Providers</span>
        <v-spacer></v-spacer>
        <v-btn @click.stop="hide" flat small fab>
          <v-icon medium class="grey--text">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :loading="providersLoading" :items="providersList">
          <!-- Items -->
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left">{{ props.item.title }}</td>
            </tr>
          </template>
          <!-- No Data -->
          <template slot="no-data">
            <v-alert :value="true" color="info" class="black--text" icon="info">
              {{ messages.info.NO_PROVIDERS_FOR_PG }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="hide">
          {{ messages.label.OK }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex"
import messages from "@/Providers/messages.json"
import ProvidersService from "@/Providers/ProvidersService"
import * as providersDataService from "@/Providers/ProvidersDataService"
import { VOD_SYCN_PREINGEST_DATA_SERVICE_URL } from "@/store/constants/getter-types"

export default {
  name: "ProvidersListDialog",
  data() {
    return {
      providersListDialog: false,
      providersLoading: false,
      headers: this.getHeaders(),
      providersList: []
    }
  },
  computed: {
    ...mapGetters([
      VOD_SYCN_PREINGEST_DATA_SERVICE_URL
    ])
  },
  methods: {
    /**
     * show - show providers list dialog
     * @param {string} providerGroupId
     */
    show(providerGroupId) {
      this.providersListDialog = true
      this.retrieveProvidersForProviderGroup(providerGroupId)
    },
    /**
     * hide - hide providers list dialog
     */
    hide() {
      this.providersListDialog = false
      this.providersList = []
    },
    /**
     * retrieveProvidersForProviderGroup - retrieve list of providers for given provider group id
     * @param {string} providerGroupId
     * @returns {Promise}
     */
    retrieveProvidersForProviderGroup(providerGroupId) {
      this.providersLoading = true
      let providersListQueryObject = {
        byProviderGroupId: providerGroupId
      }
      return providersDataService.retrieveProviders(providersListQueryObject, this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
        .then((response) => {
          if (!this.$lodash.isUndefined(response.data.entries)) {
            this.providersList = response.data.entries
          } else {
            this.providersList = []
          }
          return this.providersList
        }).catch((error) => {
          this.providersList = []
          return Promise.reject(error)
        }).finally(() => {
          this.providersLoading = false
        })
    },
    /**
    * getHeaders - Construct array of objects to show table headers
    *
    * @return {array}
    */
    getHeaders() {
      let headers = [
        {
          text: messages.label.TH_PROVIDER,
          align: "left",
          sortable: false,
          value: "title"
        }
      ]
      return headers
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages

    /**
     * Events
     */
    ProvidersService.$on("event:showProvidersListDialog", this.show)
  },
  beforeDestroy() {
    ProvidersService.$off("event:showProvidersListDialog", this.show)
  }
}
</script>
<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/Providers/ProviderGroups/ProvidersListDialog.vue